export default (language, currency, price) => {
  return new Intl.NumberFormat(language.replace('_', '-'), {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2
  }).format(price)
}
